define('plugin/classes/view/datetime/TimeClassesPluginColumnView',['require','marionette','plugin/classes/view/datetime/TimeClassesPluginItemView','plugin/classes/view/datetime/TimeClassesPluginItemEmptyView','lib/view/UnwrapBehavior'],function (require) {

    var Marionette = require('marionette');
    var TimeClassesPluginItemView = require('plugin/classes/view/datetime/TimeClassesPluginItemView');
    var TimeClassesPluginItemEmptyView = require('plugin/classes/view/datetime/TimeClassesPluginItemEmptyView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Classes provider column view
     *
     * @class TimeClassesPluginColumnView
     */
    return Marionette.CompositeView.extend({

        childView: TimeClassesPluginItemView,
        emptyView: TimeClassesPluginItemEmptyView,
        childViewContainer: '.sb_time_classes_plugin_column',
        template: '#time_classes_plugin_column_view',
        childViewOptions: function (model) {
            var from = new Time(model.get('client_time'));
            var slots = parseInt(model.get('slots_count'));

            return {
                'provider': this._providerModel,
                'service': this._serviceModel,
                'top': (100 / this._slotsCount) * ((from.getInteger() - this._timeFrom.getInteger()) / this._timeFrame),
                'height': (100 / this._slotsCount) * slots,
                'clientTimeZone': this.getOption('clientTimeZone'),
                'waitingListHelperModel': this.getOption('waitingListHelperModel'),
            };
        },

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        _slotsCount: 0,
        _timeFrom: new Time(),
        _timeTo: new Time(),
        _timeFrame: 5,
        _providerModel: null,

        initialize: function () {
            this._slotsCount = this.getOption('slotsCount');
            this._timeFrom = this.getOption('timeFrom');
            this._timeTo = this.getOption('timeTo');
            this._timeFrame = this.getOption('timeFrame');

            this._providerModel = this.getOption('providerModel');
            this._serviceModel = this.getOption('serviceModel');
        },

        serializeData: function () {
            var result = Marionette.CompositeView.prototype.serializeData.apply(this);

            result.is_wl_column = false;
            if(result.slots && result.slots.length == 0){
                result.is_wl_column = true;
            }
            return result;
        }

    });

});
